import { makeAutoObservable, observable, action, computed } from 'mobx';
import { onlineService } from './OnlineService';

export type SyncStatus = 'idle' | 'cached' | 'actualizing' | 'fresh' | 'stale';

class SyncService {
  @observable status: SyncStatus = 'idle';
  @observable lastSyncedAt: number | null = null;
  private _pendingLoads = 0;
  private _hadFailure = false;

  constructor() {
    if (typeof window !== 'undefined') {
      makeAutoObservable(this);
    }
  }

  @action
  markCached(): void {
    if (this.status === 'idle') this.status = 'cached';
  }

  @action
  trackActualize(): void {
    this._pendingLoads++;
    this._hadFailure = false;
    this.status = 'actualizing';
  }

  @action
  untrackActualize(ok: boolean): void {
    if (!ok) this._hadFailure = true;
    this._pendingLoads = Math.max(0, this._pendingLoads - 1);
    if (this._pendingLoads === 0) {
      this.status = this._hadFailure ? 'stale' : 'fresh';
      if (!this._hadFailure) this.lastSyncedAt = Date.now();
    }
  }

  @computed
  get isActualizing(): boolean {
    return this._pendingLoads > 0;
  }
}

export const syncService = new SyncService();

export function actualizeWhileOnline(fn: () => Promise<void>): void {
  if (!onlineService.isOnline) return;
  syncService.trackActualize();
  fn().then(
    () => syncService.untrackActualize(true),
    () => syncService.untrackActualize(false)
  );
}
